export const GETAUTHOR = "postReducer/authorName";
export const GETCATEGORY = "postReducer/getcategory";
export const CLOSEAUTHOR = "postReducer/closeAuthor";
export const CLOSECATEGORY = "postReducer/closeCategory";
